// import

import { body, title, bannerImage, excerpt, niceTitle, publishDate, updateDate, slug, pathSlug, links, tags, launchDate, retireDate, featured, coverImage, series, buyLinks, blurb, subtitle, articleCategory, projectCategory } from './fields';
import { createFolder, optional } from './utils';

// models

const pages = createFolder({
  name: 'pages',
  label: 'Pages',
  label_singular: 'Page',

  fields: [
    title,
    niceTitle,
    subtitle,
    pathSlug,
    publishDate,
    updateDate,
    excerpt,
    bannerImage,
    optional(body),
  ],
});

const projects = createFolder({
  name: 'projects',
  label: 'Projects',
  label_singular: 'Project',
  fields: [
    title,
    niceTitle,
    slug,
    featured,
    publishDate,
    updateDate,
    excerpt,
    projectCategory,
    launchDate,
    retireDate,
    links,
    optional(bannerImage),
    blurb,
    body,
  ],
});

const books = createFolder({
  name: 'books',
  label: 'Books',
  label_singular: 'Book',
  fields: [
    title,
    niceTitle,
    slug,
    publishDate,
    updateDate,
    excerpt,
    optional(bannerImage),
    launchDate,
    retireDate,
    coverImage,
    series,
    buyLinks,
    links,
    body,
  ],
});

const articles = createFolder({
  name: 'articles',
  label: 'Articles',
  label_singular: 'Article',
  fields: [
    title,
    niceTitle,
    slug,
    featured,
    publishDate,
    updateDate,
    excerpt,
    articleCategory,
    tags,
    optional(bannerImage),
    body,
  ],
});

// export

export const collections = [
  pages,
  projects,
  books,
  articles,
];
